import React from 'react';
import { Table, Card, Tabs, Typography } from 'antd';
import styles from './Network.module.scss';

const { TabPane } = Tabs;
const { Text } = Typography;

const NetworkNtp = ({ ntpConfig, ntpStatus }) => {
  // NTP 설정 파싱
  const parseNtpConfig = (config) => {
    if (!config || config === 'N/A') return [];
    
    try {
      const servers = [];
      const lines = config.trim().split('\n');
      
      lines.forEach(line => {
        if (line.startsWith('server ')) {
          const parts = line.split(/\s+/);
          const server = parts[1];
          const options = parts.slice(2).join(' ');
          
          servers.push({
            server,
            options,
            key: server
          });
        }
      });
      
      return servers;
    } catch (error) {
      console.error('Error parsing NTP config:', error);
      return [];
    }
  };
  
  // NTP 상태 파싱
  const parseNtpStatus = (status) => {
    if (!status || status === 'N/A') return [];
    
    try {
      const servers = [];
      const lines = status.trim().split('\n');
      
      // 헤더 라인 건너뛰기
      const dataLines = lines.slice(2);
      
      dataLines.forEach(line => {
        const parts = line.trim().split(/\s+/);
        if (parts.length >= 6) {
          servers.push({
            remote: parts[0],
            refid: parts[1],
            st: parts[2],
            type: parts[3],
            when: parts[4],
            poll: parts[5],
            reach: parts[6],
            delay: parts[7],
            offset: parts[8],
            jitter: parts[9],
            key: parts[0]
          });
        }
      });
      
      return servers;
    } catch (error) {
      console.error('Error parsing NTP status:', error);
      return [];
    }
  };

  const servers = parseNtpConfig(ntpConfig);
  const status = parseNtpStatus(ntpStatus);

  return (
    <Card title="NTP 서버 정보" className={styles.networkCard}>
      <Tabs defaultActiveKey="config">
        <TabPane tab="NTP 서버 구성" key="config">
          {servers.length > 0 ? (
            <Table 
              dataSource={servers}
              rowKey="server"
              pagination={false}
              columns={[
                { title: '서버', dataIndex: 'server', key: 'server' },
                { title: '옵션', dataIndex: 'options', key: 'options' }
              ]}
            />
          ) : (
            <Text type="secondary">NTP 서버 구성 정보가 없습니다.</Text>
          )}
        </TabPane>
        <TabPane tab="NTP 서버 상태" key="status">
          {status.length > 0 ? (
            <Table 
              dataSource={status}
              rowKey="remote"
              pagination={false}
              columns={[
                { title: '원격 서버', dataIndex: 'remote', key: 'remote' },
                { title: 'RefID', dataIndex: 'refid', key: 'refid' },
                { title: '계층', dataIndex: 'st', key: 'st' },
                { title: '타입', dataIndex: 'type', key: 'type' },
                { title: '지연', dataIndex: 'delay', key: 'delay' },
                { title: '오프셋', dataIndex: 'offset', key: 'offset' },
                { title: '지터', dataIndex: 'jitter', key: 'jitter' }
              ]}
            />
          ) : (
            <Text type="secondary">NTP 서버 상태 정보가 없습니다.</Text>
          )}
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default NetworkNtp;